export default function CustomField(){
    return  [
        {
            fieldId: 'driver_number',
            displayName: 'Driver Number'
        },
        {
            fieldId: 'driver_name',
            displayName:'Driver Name'
        },
        {
            fieldId: 'vehicle_number',
            displayName: 'Vehicle number'
        },
        {
            fieldId: 'trip_location_source',
            displayName: 'Location Source'
        },
        {
            fieldId: 'portableTrackerId',
            displayName: 'Portable Tracker ID'
        },
        {
            fieldId:'lr_number',
            displayName:'Lorry Receipt Number'
        }
    ]
}
